// extracted by mini-css-extract-plugin
module.exports = {"container":"ScreenLoader_container__1ADxK","visible":"ScreenLoader_visible__M6ubE","loader":"ScreenLoader_loader__0kr2n","loading":"ScreenLoader_loading__X3Kd2"};